// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="inventory-checks-list" class="box product-operation">
  <sub-header header="'Encash on-us check'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
          {{\$ctrl.depositAccount.productName}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
          {{\$ctrl.depositAccount.balance | nxCurrency}}
        </span>
      </div>
    </div>


    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">

        <tbody>
        <tr>
          <td>1.</td>
          <td>MICR number</td>
          <td>
            <input
              required
              type="text"
              class="check-no"
              ng-model="\$ctrl.check.micrNumber"
              ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
              ui-mask-placeholder
              ui-options="{clearOnBlur: false}"
              maxlength="64"/>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Valid from</td>
          <td>
            <date output-format="date"
              ng-model="\$ctrl.check.validFrom"
              ng-required="true"></date>
          </td>
        </tr>
        <tr>
          <td>3.</td>
          <td>Amount</td>
          <td>
            <cash ng-required="true"
              ng-model="\$ctrl.check.amount"></cash>
          </td>
        </tr>
        <tr>
          <td>4.</td>
          <td>Payee</td>
          <td>
            <input
              type="text"
              required
              ng-model="\$ctrl.check.payee"/>
          </td>
        </tr>
        <tr>
          <td>5.</td>
          <td>Remarks</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.check.remarks"
              ng-required="false">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <signature-card
          file-id="\$ctrl.depositAccount.signatureCardFileId"
          product-group="'ACCOUNT'"
          product-status="\$ctrl.depositAccount.status"></signature-card>
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-danger"
                ng-click="\$ctrl.encash()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Encash check
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/encash/encash-on-us-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;